import { createActionCreator, paramsEncode,dateConversion } from '../utils/';
import Url from '../../config/';
import constant from '../utils/constant';
import request from '../utils/request';

//改状态
export const createLoadingAction = createActionCreator(constant.SHOWUSERLOADING, loading => loading);// 显示loading
export const createShowAddAction = createActionCreator(constant.SHOWUSERADD, adding => adding);// 显示新增场次弹窗 
export const createShowEditAction = createActionCreator(constant.SHOWUSEREDIT, editing => editing);// 显示修改场次弹窗 

// 获取数据
export const createListAction = createActionCreator(constant.GETUSERLIST, list => list); // 存储用户列表
export const createpagetTotolAction = createActionCreator(constant.GETPAGETOTAL, total => total); // 存储列表总页数
export const createGetDetailAction = createActionCreator(constant.GETDETAIL, name => name);// 查询每人信息 

//获取用户列表流信息
export const getList = (params) => {
    let url = Url.UserUrl.list + paramsEncode(params).replace(/\&/, '?');
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            const data=await request(url);
            const userList=data.list.map((v,k)=>{
                return {...v,created:dateConversion(v.created),role:v.role==1?'管理员':'普通用户'}
            })
            dispatch(createListAction(userList));
            dispatch(createpagetTotolAction(data.total));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    }
};

// 获取用户详情
export const getDetail = (name) => {
    let url = Url.UserUrl.getInfo + '?name='+name+'';
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            const data=await request(url);
            dispatch(createGetDetailAction(data));
            dispatch(createShowEditAction(true));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    }
};
// 提交修改
export const modifyUser = (value) => {
    let url = Url.UserUrl.modify;
    return async (dispatch, getState) => {
        try {
            const data=await request(url,'post',value);
            dispatch(createShowEditAction(false));
        } catch (e) {
            throw new Error(e);
        } finally {
        }
    }
};
// 提交新增
export const addUser = (value) => {
    let url = Url.UserUrl.add;
    return async (dispatch, getState) => {
        try {
            const data=await request(url,'post',value);
            dispatch(createShowAddAction(false));
        } catch (e) {
            throw new Error(e);
        } finally {
        }
    }
};
// 删除用户
export const delUser = (id) => {
    let url = Url.UserUrl.del + '?id='+id+'';
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            const data=await request(url,'delete');
        } catch (e) {
            console.log(e);
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    }
};

// 提交修改
export const modifySelf = (value) => {
    let url = Url.UserUrl.modifySelf;
    return async (dispatch, getState) => {
        try {
            const data=await request(url,'post',value);
        } catch (e) {
            throw new Error(e);
        } finally {
        }
    }
};


// WEBPACK FOOTER //
// ./actions/user.js